import { WALLET_AWARD_MODAL_ID, WALLET_AWARD_STATUS } from './types/modals';

/** WEB-210837 AC5: NUA expiring-soon threshold. AC is source of truth (not AEM common.expiringSoonDays). */
export const WALLET_NUA_EXPIRING_SOON_DAYS = 90;

/** Available NUA tile id aligns with BAU modal routing key. */
export const WALLET_NUA_AVAILABLE_ITEM_ID = WALLET_AWARD_MODAL_ID.NUA_AVAILABLE;

/** UXL currencies statusInfo.statusType values. */
export const NUA_UXL_STATUS_TYPE = {
  AVAILABLE: 'AVAILABLE',
  REQUESTED: 'REQUESTED',
  APPROVED: 'APPROVED',
  GUARANTEED: 'GUARANTEED',
  PENDING: 'PENDING',
} as const;

/** Trip nuaRequestStatus values normalized to Approved tile (BAU classifyNuaStatus). */
export const NUA_UXL_TRIP_STATUS_APPROVED = ['APPROVED', 'CONFIRMED', 'GRANTED', 'GUARANTEED'] as const;

/** Trip nuaRequestStatus values normalized to Request Pending tile. */
export const NUA_UXL_TRIP_STATUS_PENDING = ['REQUESTED', 'PENDING', 'REQUEST_PENDING', 'REQUESTPENDING'] as const;

/** statusInfo.statusType values for pending modal expiry groups (WEB-210837 AC6). */
export const NUA_UXL_STATUS_INFO_PENDING = [NUA_UXL_STATUS_TYPE.REQUESTED, NUA_UXL_STATUS_TYPE.PENDING] as const;

/** statusInfo.statusType values for guaranteed/approved modal expiry (iOS uses Guaranteed bucket). */
export const NUA_UXL_STATUS_INFO_GUARANTEED = [NUA_UXL_STATUS_TYPE.GUARANTEED, NUA_UXL_STATUS_TYPE.APPROVED] as const;

/** @deprecated Use NUA_UXL_STATUS_INFO_GUARANTEED for iOS-aligned FIFO expiry. */
export const NUA_UXL_STATUS_INFO_APPROVED = [NUA_UXL_STATUS_TYPE.APPROVED] as const;

/** reservationDetails.statusType paired with Requested statusInfo (Available on iOS; Requested on web UXL). */
export const NUA_UXL_RESERVATION_STATUS_FOR_REQUESTED = [
  NUA_UXL_STATUS_TYPE.AVAILABLE,
  NUA_UXL_STATUS_TYPE.REQUESTED,
  NUA_UXL_STATUS_TYPE.PENDING,
] as const;

/** reservationDetails.statusType paired with Guaranteed statusInfo. */
export const NUA_UXL_RESERVATION_STATUS_FOR_GUARANTEED = [
  NUA_UXL_STATUS_TYPE.GUARANTEED,
  NUA_UXL_STATUS_TYPE.APPROVED,
] as const;

export const normalizeNuaUxlStatusType = (statusType?: string): string =>
  statusType?.replace(/\s+/g, '').toUpperCase() ?? '';

export { WALLET_AWARD_MODAL_ID, WALLET_AWARD_STATUS };
